/* eslint-disable import/no-cycle */
import {
  GET_ALL_HUB_CONTENT,
  GET_WIN_WIRE_MESSAGES,
  ADD_WIN_WIRE_REACTION,
  REMOVE_WIN_WIRE_REACTION,
  SEND_WIN_WIRE_REPLY,
  INSIGHT_NOTIFICATIONS,
  REMOVE_HUB_NOTIFICATIONS,
  INCREMENT_NOTIFICATION,
  EDIT_WIN_WIRE_REPLY,
  REMOVE_WIN_WIRE_REPLY,
  MUTE_INSIGHT,
} from "lib/constants";
import { getAPICall, postAPICall, deleteAPICall } from "../lib/callApi";

export const fetchHubContent = async (payload) => {
  const data = await getAPICall(GET_ALL_HUB_CONTENT, true, payload);
  return data;
};

export const fetchWinWireMessages = async (payload) => {
  const data = await getAPICall(GET_WIN_WIRE_MESSAGES, true, payload);
  return data;
};

export const fetchAllNotifications = async (payload) => {
  const data = await getAPICall(INSIGHT_NOTIFICATIONS, true, payload);
  return data;
};

export const addWinWireReaction = async (payload) => {
  const data = await postAPICall(ADD_WIN_WIRE_REACTION, true, payload);
  return data;
};

export const addWinWireReply = async (payload) => {
  const data = await postAPICall(SEND_WIN_WIRE_REPLY, true, payload);
  return data;
};

export const editWinWireReply = async (payload) => {
  const data = await postAPICall(EDIT_WIN_WIRE_REPLY, true, payload);
  return data;
};

export const removeWinWireReaction = async (payload) => {
  const data = await deleteAPICall(REMOVE_WIN_WIRE_REACTION, true, payload);
  return data;
};

export const removeWinWireReply = async (payload) => {
  const data = await deleteAPICall(REMOVE_WIN_WIRE_REPLY, true, payload);
  return data;
};

export const removeHubNotifications = async (payload) => {
  const data = await postAPICall(REMOVE_HUB_NOTIFICATIONS, true, payload);
  return data;
};

export const incrementHubNotification = async (payload) => {
  const data = await postAPICall(INCREMENT_NOTIFICATION, true, payload);
  return data;
};

export const muteNotification = async (payload) => {
  const data = await postAPICall(MUTE_INSIGHT, true, payload);
  return data;
};
